/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MdmIngestExecutionDto
 */
export interface MdmIngestExecutionDto {
    /**
     * 
     * @type {string}
     * @memberof MdmIngestExecutionDto
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmIngestExecutionDto
     */
    executionId?: string;
    /**
     * 
     * @type {number}
     * @memberof MdmIngestExecutionDto
     */
    totalJobs?: number;
    /**
     * 
     * @type {number}
     * @memberof MdmIngestExecutionDto
     */
    completeJobs?: number;
    /**
     * 
     * @type {number}
     * @memberof MdmIngestExecutionDto
     */
    failedJobs?: number;
    /**
     * 
     * @type {number}
     * @memberof MdmIngestExecutionDto
     */
    pendingJobs?: number;
    /**
     * 
     * @type {number}
     * @memberof MdmIngestExecutionDto
     */
    runningJobs?: number;
    /**
     * 
     * @type {number}
     * @memberof MdmIngestExecutionDto
     */
    maxCompleteDurationSeconds?: number;
}

/**
 * Check if a given object implements the MdmIngestExecutionDto interface.
 */
export function instanceOfMdmIngestExecutionDto(value: object): value is MdmIngestExecutionDto {
    return true;
}

export function MdmIngestExecutionDtoFromJSON(json: any): MdmIngestExecutionDto {
    return MdmIngestExecutionDtoFromJSONTyped(json, false);
}

export function MdmIngestExecutionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MdmIngestExecutionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'executionId': json['executionId'] == null ? undefined : json['executionId'],
        'totalJobs': json['totalJobs'] == null ? undefined : json['totalJobs'],
        'completeJobs': json['completeJobs'] == null ? undefined : json['completeJobs'],
        'failedJobs': json['failedJobs'] == null ? undefined : json['failedJobs'],
        'pendingJobs': json['pendingJobs'] == null ? undefined : json['pendingJobs'],
        'runningJobs': json['runningJobs'] == null ? undefined : json['runningJobs'],
        'maxCompleteDurationSeconds': json['maxCompleteDurationSeconds'] == null ? undefined : json['maxCompleteDurationSeconds'],
    };
}

export function MdmIngestExecutionDtoToJSON(json: any): MdmIngestExecutionDto {
    return MdmIngestExecutionDtoToJSONTyped(json, false);
}

export function MdmIngestExecutionDtoToJSONTyped(value?: MdmIngestExecutionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenantId': value['tenantId'],
        'executionId': value['executionId'],
        'totalJobs': value['totalJobs'],
        'completeJobs': value['completeJobs'],
        'failedJobs': value['failedJobs'],
        'pendingJobs': value['pendingJobs'],
        'runningJobs': value['runningJobs'],
        'maxCompleteDurationSeconds': value['maxCompleteDurationSeconds'],
    };
}

